import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import "../Asociados/createAsociados.css";
import "./createProduct.css";

import { useFormik } from "formik";
import { proveedorFormValidate } from "../../../../helper/validate";
import toast from "react-hot-toast";
import * as api from "helper/helper";
import "./../formsCommons.css";
import buttonStyles from "../../../../styles/Button.module.css";

// CHECAR import useSearchList, { useFormInput } from "../../../../hooks/custom.hooks";
//import stylesPro from "./createProduct.module.css";
import { FaPlus } from "react-icons/fa6";
import invalidClass, { formikExtra } from "../../helperFunctions/helpers";
import LoadingButton from "../LoadingButton/LoadingButton";
import { PermissionsForSection } from "../auth";
import { Sections } from "../../data/navItem";
import CreateAddressModal from "../Address/CreateAddressModal";
import AddressTag from "../Address/AddressTag";
import BankTag from "../Bank/BankTag";
import CreateBancoModal from "../Address/CreateBancoModal";

const CreateProveedor = forwardRef(({ item, reloadProveedor }, ref) => {
  const modalRef = useRef();
  const buttonCancelModalRef = useRef();

  const createAddressRef = useRef();
  const createBancosRef = useRef();

  const isSaveDisable = useRef();
  const fieldsSetup = useRef({});

  /// CHECAR  useTraceUpdate(props, "CreateProduct");
  const [isActiveDisabled, setIsActiveDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const [modalData, setModalData] = useState(null);
  const [direcciones, setDirecciones] = useState([]);
  const [bancos, setBancos] = useState([]);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  const createMode = item == null || (item && Object.keys(item).length === 0);

  useEffect(() => {
    console.log("---> change item: " + item);
    let isActiveDisable = createMode;
    setIsActiveDisabled(isActiveDisable);

    setDirecciones([]);
    setBancos([]);

    if (item == null) {
      return;
    }

    formik?.resetForm();
  }, [item]);

  const [marcas, setMarcas] = useState([
    { id: 0, nombre: "Selecciona una marca..." },
  ]);

  const [generos, setGenero] = useState([
    { id: 0, nombre: "Selecciona un genero..." }, //tipo de producto..." },
    //  ...Genero,
  ]);

  const [tamaños, setTamaños] = useState([
    { id: 0, nombre: "Selecciona un tamaño..." },
  ]);

  const [concentraciones, setConcentraciones] = useState([
    { id: 0, nombre: "Selecciona una concentración..." },
  ]);

  const [presentaciones, setPresentaciones] = useState([
    { id: 0, nombre: "Selecciona una presentación..." },
  ]);

  /*

  const [categories] = useState([
    { id: 0, nombre: "Selecciona una categoria..." },
    ...CategoriasProducto,
  ]);*/

  let tags = null;

  const fetchData = async () => {
    const response = await api.marcas().catch((e) => {
      toast.error("Error al pedir usuarios.");
    });
    if (!response) return;

    setMarcas([...marcas, ...response.data]);

    const responseGenero = await api.generos().catch((e) => {
      toast.error("Error al pedir generos.");
    });
    if (!responseGenero) return;

    setGenero([...generos, ...responseGenero.data]);

    const responseTamano = await api.tamaños().catch((e) => {
      toast.error("Error al pedir tamaños.");
    });
    if (!responseTamano) return;

    setTamaños([...tamaños, ...responseTamano.data]);

    const responseConcentracion = await api.concentraciones().catch((e) => {
      toast.error("Error al pedir concentraciones.");
    });
    if (!responseConcentracion) return;

    setConcentraciones([...concentraciones, ...responseConcentracion.data]);

    const responsePresentaciones = await api.presentaciones().catch((e) => {
      toast.error("Error al pedir presentaciones.");
    });
    if (!responsePresentaciones) return;

    setPresentaciones([...presentaciones, ...responsePresentaciones.data]);

    console.log(responsePresentaciones.status);
  };

  useEffect(() => {
    setDirecciones(item?.direcciones ?? []);
  }, [item?.direcciones]);

  useEffect(() => {
    setBancos(item?.bancos ?? []);
  }, [item?.bancos]);

  useEffect(() => {
    formik?.resetForm();

    const newPermissions = PermissionsForSection(Sections.Productos);
    setPermissions(newPermissions);

    fetchData();
  }, []);

  let initialValues = {
    id: 0,
    nombre: "",
    rfc: "",
    direcciones: [],
    bancos: [],
    correo: "",
    telefono: "",

    activo: true,
  };

  //tagRef.current?.removeAll();
  if (!createMode) {
    //const images = item.productImagePathsString?.split(",") ?? [];
    /*images = images.map((el) => ImagePathBuilder.to(el));

    setInsideImages(images);
    */
    //--dragDropRef.current.setSelectedFiles(images);
    //let tags = tagRef.current.getTags().values.split(",");
    //tags = tags.map(el => el.trim());

    /*values.tags = tagRef.current.getTags().values.join(", ");
      tagRef.current.
      array = array.map(el => el.trim());*/

    initialValues = {
      id: item.id,
      nombre: item.nombre,
      rfc: item.rfc,
      direcciones: [],
      bancos: [],
      correo: item.correo,
      telefono: item.telefono,

      activo: item.activo,
    };
  }

  //console.log("-->");
  //console.log(initialValues);

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validate: proveedorFormValidate,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { props, setSubmitting }) => {
      //  values.tags = tagRef.current.getTags().values.join(",");
      //is - invalid;
      console.log(tags);

      /*
      No enviar “NumProducto”, 
      “CategoriaId”, 
      “PrecioCosto” y 
      “PrecioVenta” en Crear/Editar.
*/
      /*
      delete values["precioCosto"];
      delete values["precioVenta"];
      delete values["sku"];*/

      setIsLoading(true);

      if (direcciones.length > 0) {
        for (let index = 0; index < direcciones.length; index++) {
          let direccion = direcciones[index];
          if (direccion.id > 0) {
            continue;
          }

          delete direccion.id;
          delete direccion.isNew;
        }
        values.direcciones = direcciones;
      }

      if (bancos.length > 0) {
        for (let index = 0; index < bancos.length; index++) {
          let banco = bancos[index];
          if (banco.id > 0) {
            continue;
          }

          delete banco.id;
          delete banco.isNew;
        }
        values.bancos = bancos;
      }

      if (values.id === 0) {
        const toastId = toast.loading("Creando Proveedor...");
        let response = await api.createProveedor(values, null).catch((e) => {
          toast.dismiss(toastId);
          setIsLoading(false);
          if (e.esError && e.codigoError && e.mensaje) {
            toast.error(`Error al crear Proveedor. ${e.mensaje}`);
            return;
          }
          toast.error("Error al crear Proveedor.");
        });

        toast.dismiss(toastId);
        setIsLoading(false);

        if (!response) return;

        toast.success("Proveedor creado.");
        reloadProveedor();

        buttonCancelModalRef.current.click();
      } else {
        const toastId = toast.loading("Actualizando Proveedor...");
        setIsLoading(true);
        const response = await api
          .updateProveedor(values.id, values)
          .catch((e) => {
            setIsLoading(false);
            toast.dismiss(toastId);
            toast.error("Error al actualizar Proveedor.");
          });
        if (!response) return;

        const responseActivo = await api
          .activarProveedor(values.id, values.activo)
          .catch((e) => {
            setIsLoading(false);
            toast.dismiss(toastId);
            toast.error("Error al actualizar activo Proveedor.");
          });

        toast.dismiss(toastId);
        setIsLoading(false);

        if (!responseActivo) return;

        setIsLoading(false);

        buttonCancelModalRef.current.click();

        toast.dismiss(toastId);
        toast.success("Proveedor actualizado.");
        reloadProveedor();
      }
    },
  });

  useImperativeHandle(ref, () => ({
    getValue: () => {
      return formik.values;
    },
    toggleModal: () => {
      formik?.resetForm();
      modalRef.current.click();
    },
  }));

  /*
    BancosTag handle
    */
  function createEditBanco(event, item = null) {
    setModalData(item);
    createBancosRef.current.toggleModal();
  }

  function deleteBanco(event, deleteItem) {
    const updated = bancos.filter((item) => item.id !== deleteItem.id);
    setBancos(updated);
    //formik.setFieldValue("direcciones", updated);
    //formik.values.direcciones = updated;
  }

  /*
    AddressTag handle
    */
  function createEditAddress(event, item = null) {
    setModalData(item);
    createAddressRef.current.toggleModal();
  }

  function deleteAddress(event, deleteItem) {
    const updated = direcciones.filter((item) => item.id !== deleteItem.id);
    setDirecciones(updated);
    //formik.setFieldValue("direcciones", updated);
    //formik.values.direcciones = updated;
  }

  /** manage address add/edit */
  function handleAddressViewChanges(item) {
    /*
      item.isNew
      item.id -> contiene {num} = editado
      */
    if (item.isNew) {
      delete item.isNew;
      item.id = -Date.parse(Date());
      const newDirecciones = direcciones.concat(item);
      setDirecciones(newDirecciones);
    } else {
      const index = direcciones.findIndex((value) => item.id === value.id);
      if (index !== -1) {
        direcciones.splice(index, 1, item);
        const allDirecciones = [...direcciones];
        setDirecciones(allDirecciones);
      }
    }
  }

  function handleBancoViewChanges(item) {
    /*
      item.isNew
      item.id -> contiene {num} = editado
      */
    if (item.isNew) {
      delete item.isNew;
      item.id = -Date.parse(Date());
      const newBancos = bancos.concat(item);
      setBancos(newBancos);
    } else {
      const index = bancos.findIndex((value) => item.id === value.id);
      if (index !== -1) {
        bancos.splice(index, 1, item);
        const allBancos = [...bancos];
        setBancos(allBancos);
      }
    }
  }

  function setupFields() {
    // fieldsSetup
    fieldsSetup.current = {};

    for (const [key, value] of Object.entries(initialValues)) {
      console.log(`${key}: ${value}`);

      const res = api.isFieldReadOnlyWith(createMode, value);
      fieldsSetup.current[key] = res;
    }
  }

  return (
    <>
      <button
        ref={modalRef}
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdropCrearProovedor"
        hidden
      >
        Abrir Crear Producto
      </button>

      <div
        className="modal fade modal-lg"
        id="staticBackdropCrearProovedor"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropCrearProovedorLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                {createMode ? "Crear" : "Editar"} Proveedor
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div
              className="modal-body"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <form
                className="row g-3"
                onSubmit={(event) => {
                  event.preventDefault();
                  return false;
                }}
              >
                <div className="form-control">
                  <h5>Información General</h5>

                  <div className="row">
                    <div className="col align-self-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Nombre
                      </label>
                      <input
                        type="text"
                        className={`form-control ${invalidClass(
                          formik.errors.nombre,
                        )}`}
                        id="validationName"
                        aria-describedby="emailHelp"
                        {...formik.getFieldProps("nombre")}
                        {...formikExtra.upperCase("nombre", formik)}
                      />
                      <div className="valid-feedback"></div>
                      <div className="invalid-feedback">
                        {formik.errors.nombre}
                      </div>
                    </div>

                    <div className="col-2 align-container-center">
                      <div className="container-center-horizontal">
                        <div className="form-check form-switch container-center-vertical">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="flexSwitchCheckDefault"
                            {...formik.getFieldProps("activo")}
                            checked={formik.values.activo}
                            disabled={
                              isActiveDisabled || !permissions.canActivar
                            }
                          />
                          <span>
                            <label
                              className="form-check-label"
                              htmlFor="flexSwitchCheckDefault"
                            >
                              Activo
                            </label>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="row">
                      <div className="col align-self-start">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label"
                        >
                          RFC
                        </label>
                        <input
                          type="text"
                          className={`form-control ${invalidClass(
                            formik.errors.rfc,
                          )}`}
                          id="validationName"
                          aria-describedby="emailHelp"
                          {...formik.getFieldProps("rfc")}
                          {...formikExtra.upperCase("rfc", formik)}
                        />
                        <div className="valid-feedback"></div>
                        <div className="invalid-feedback">
                          {formik.errors.rfc}
                        </div>
                      </div>
                      <div className="col align-self-start">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label"
                        >
                          Email
                        </label>
                        <input
                          type="text"
                          className={`form-control ${invalidClass(
                            formik.errors.email,
                          )}`}
                          id="validationName"
                          aria-describedby="emailHelp"
                          {...formik.getFieldProps("correo")}
                          {...formikExtra.upperCase("correo", formik)}
                        />
                        <div className="valid-feedback"></div>
                        <div className="invalid-feedback">
                          {formik.errors.correo}
                        </div>
                      </div>
                      <div className="col align-self-start">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label"
                        >
                          Telefono
                        </label>
                        <input
                          type="text"
                          className={`form-control ${invalidClass(
                            formik.errors.telefono,
                          )}`}
                          id="validationName"
                          aria-describedby="emailHelp"
                          {...formik.getFieldProps("telefono")}
                          {...formikExtra.upperCase("telefono", formik)}
                        />
                        <div className="valid-feedback"></div>
                        <div className="invalid-feedback">
                          {formik.errors.telefono}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="mb-3"></div>
                  </div>
                </div>

                <div className="">
                  <div className="separator">
                    <h5 className="card-title">
                      Bancos
                      <span>
                        <button
                          className="btn btn-primary"
                          style={{ marginLeft: "20px" }}
                          onClick={(event) => createEditBanco(event, {})}
                          disabled={fieldsSetup.current.bancos}
                        >
                          <div className={buttonStyles.icon_button}>
                            <FaPlus />
                            Agregar
                          </div>
                        </button>
                      </span>
                    </h5>
                    {bancos?.map((item, index) => {
                      const datas = [
                        item.nombre,
                        item.cuenta ?? "",
                        item.alias ?? "",
                      ];
                      const filtered = datas.filter((item) => item);
                      const value = filtered.join(", ");
                      return (
                        <BankTag
                          key={index}
                          value={value}
                          item={item}
                          createEditAddress={createEditBanco}
                          deleteAddress={deleteBanco}
                          isDisable={fieldsSetup.current.bancos}
                        />
                      );
                    })}
                  </div>
                </div>

                <div className="">
                  <div className="separator">
                    <h5 className="card-title">
                      Direcciones
                      <span>
                        <button
                          className="btn btn-primary"
                          style={{ marginLeft: "20px" }}
                          onClick={(event) => createEditAddress(event, {})}
                          disabled={fieldsSetup.current.direcciones}
                        >
                          <div className={buttonStyles.icon_button}>
                            <FaPlus />
                            Agregar
                          </div>
                        </button>
                      </span>
                    </h5>
                    {direcciones?.map((item, index) => {
                      const datas = [
                        item.nombre,
                        item.cp ?? "",
                        item.calle ?? "",
                        item.estado ?? "",
                        item.ciudad ?? "",
                        item.noExterior ?? "",
                        item.noInterior ?? "",
                        item.referencia ?? "",
                      ];
                      const filtered = datas.filter((item) => item);
                      const value = filtered.join(", ");
                      return (
                        <AddressTag
                          key={index}
                          value={value}
                          item={item}
                          createEditAddress={createEditAddress}
                          deleteAddress={deleteAddress}
                          isDisable={fieldsSetup.current.direcciones}
                        />
                      );
                    })}
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                    ref={buttonCancelModalRef}
                  >
                    Cancelar
                  </button>
                  <LoadingButton
                    style={{ height: "38px" }}
                    onClick={(e) => {
                      formik.handleSubmit();
                    }}
                    text={"Guardar"}
                    loadingText={"Guardando..."}
                    isLoading={isLoading}
                    hidden={!permissions.canEdit}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <CreateAddressModal
        ref={createAddressRef}
        returnToModalId="staticBackdropCrearProovedor"
        item={modalData}
        reloadDireccion={handleAddressViewChanges}
      />

      <CreateBancoModal
        ref={createBancosRef}
        returnToModalId="staticBackdropCrearProovedor"
        item={modalData}
        reloadBanco={handleBancoViewChanges}
      />
    </>
  );
});

export default CreateProveedor;
